class QuickViewDrawer {
  constructor() {
    this.drawer = document.getElementById('QuickViewDrawer');
    if (!this.drawer) return;

    this.closeBtn = this.drawer.querySelector('.quick-view-drawer__close');
    this.gallery = this.drawer.querySelector('.quick-view-drawer__gallery');
    this.info = this.drawer.querySelector('.quick-view-drawer__info-body');
    this.currentProduct = null;

    this.bindEvents();
  }

  bindEvents() {
    this.closeBtn.addEventListener('click', () => this.close());

    this.drawer.addEventListener('click', (e) => {
      if (e.target.closest('.quick-view-drawer__info')) return;
      if (window.innerWidth <= 749 && e.target.closest('.quick-view-drawer__gallery')) return;
      if (e.target.tagName === 'IMG') return;
      this.close();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-drawer-trigger]');
      if (trigger) {
        e.preventDefault();
        this.open(trigger.dataset.productUrl, trigger);
      }
    });
  }

  open(productUrl, trigger) {
    const cleanUrl = productUrl.split('?')[0];
    if (trigger) {
      trigger.setAttribute('aria-disabled', true);
      trigger.classList.add('loading');
      trigger.querySelector('.loading__spinner')?.classList.remove('hidden');
      
      if (trigger.dataset.isPanel === 'true') {
        this.drawer.classList.add('quick-view-drawer--panel');
      } else {
        this.drawer.classList.remove('quick-view-drawer--panel');
      }
    }

    const sectionId = trigger && trigger.dataset.isPanel === 'true' ? 'quick-view-panel-info' : 'quick-view-drawer-info';

        Promise.all([
      fetch(`${cleanUrl}.js`).then((r) => r.json()),
      fetch(`${cleanUrl}?sections=${sectionId}`).then((r) => r.json()),
    ])

      .then(([product, sections]) => {
        this.currentProduct = product;
        this.renderGallery(product, product.variants[0]);
        this.info.innerHTML = sections[sectionId];
        this.bindInfoEvents();
        setTimeout(() => this.drawer.classList.add('is-open'));
        document.body.style.overflow = 'hidden';
      })
      .catch((err) => console.error('Quick view error:', err))
      .finally(() => {
        if (trigger) {
          trigger.removeAttribute('aria-disabled');
          trigger.classList.remove('loading');
          trigger.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      });
  }

  close() {
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    this.drawer.addEventListener(
      'transitionend',
      () => {
        this.gallery.innerHTML = '';
        this.info.innerHTML = '';
        this.currentProduct = null;
      },
      { once: true }
    );
  }

  renderGallery(product, activeVariant) {
    const images = product.media.filter((m) => m.media_type === 'image');
    const featuredMediaId = activeVariant?.featured_media?.id;

    let sorted = images;
    if (featuredMediaId) {
      const featured = images.find((m) => m.id === featuredMediaId);
      const rest = images.filter((m) => m.id !== featuredMediaId);
      sorted = featured ? [featured, ...rest] : images;
    }

    this.gallery.innerHTML = sorted
      .map(
        (media, index) => `
        <img
          src="${media.src}"
          alt="${media.alt || product.title}"
          width="${media.width}"
          height="${media.height}"
          data-media-id="${media.id}"
          loading="${index === 0 ? 'eager' : 'lazy'}"
        >
      `
      )
      .join('');
  }

  swapFirstImage(variant) {
    if (!variant?.featured_media) return;
    const media = this.currentProduct.media.find((m) => m.id === variant.featured_media.id);
    if (!media) return;

    const firstImg = this.gallery.querySelector('img');
    if (firstImg) {
      firstImg.src = media.src;
      firstImg.alt = media.alt || this.currentProduct.title;
      firstImg.dataset.mediaId = media.id;
    }
  }

  bindInfoEvents() {
    this.info.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        const selectedValues = {};
        this.info.querySelectorAll('fieldset').forEach((fs, i) => {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) selectedValues[i] = checked.value;
        });

        const variant = this.currentProduct.variants.find((v) =>
          Object.keys(selectedValues).every(
            (i) => v[`option${parseInt(i) + 1}`] === selectedValues[i]
          )
        );

        if (variant) {
          this.swapFirstImage(variant);

          const variantInput = this.info.querySelector('.product-variant-id');
          if (variantInput) variantInput.value = variant.id;

          const btn = this.info.querySelector('[name="add"]');
          if (btn) {
            btn.disabled = !variant.available;
            btn.querySelector('span').textContent = variant.available
              ? btn.dataset.addToCart
              : btn.dataset.soldOut;
          }
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickViewDrawer();
});
